import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'

import { SUI, Button, Icon, Flex } from 'shared/ui'

const MergeIcon = styled(({ className, flipped = false }) => (
  <Icon
    className={cn(className, { flipped })}
    color="color.monochrome.white"
    name="merge"
    size="xsmall"
  />
))`
  margin-top: 3px;
  margin-left: -4px;
  margin-right: -4px;

  &.flipped {
    transform: rotate(180deg) translateX(2px);
  }
`

const MergeDirectionToggle = ({ className, direction, onClick }) => {
  const normal = direction === 'normal'
  const text = `Merging ${normal ? 'Into Above' : 'Into Below'}`

  return (
    <SUI>
      <Button
        className={cn('grui mt-10', className)}
        onClick={onClick}
        primary
        size="medium"
      >
        <Flex className="grui flex-1-0-auto">
          <MergeIcon flipped={!normal} />
          <div className="grui ml-10">{text}</div>
        </Flex>
      </Button>
    </SUI>
  )
}

export default MergeDirectionToggle
